<template>
  <div class="order_detail">
    <titleBar :title="title" :callback="true" @callback="exit_event"></titleBar>
    <p v-if="data.orderState == 1" class="wait_pay">
      等待付款 还剩
      <time_count :time="data.expired" @time_count_end="time_count_end"></time_count>自动取消
    </p>
    <div v-else-if="data.orderState == 2" class="pay_status">
      <i class="sucess_icon"></i>
      <span class="sucess_font">支付成功</span>
    </div>
    <div v-else-if="data.orderState == 3" class="pay_status">
      <i class="cannel_icon"></i>
      <span class="cannel_font">订单已取消</span>
    </div>
    <div
      v-if="data.address && data.address.address && data.address.address.length != 0"
      class="order_mes"
    >
      <p class="mes_top">
        <i></i>
        <span class="name">{{data.address.address.addrUname}}</span>
        <span>{{data.address.address.mobile}}</span>
      </p>
      <p class="ad_mes">{{data.address.address.addrInfo}} {{data.address.address.addrDetail}}</p>
    </div>
    <div class="lessonItem" v-for="(v , i) in data.productList">
      <div class="item">
        <h2>{{v.orderTitle}}</h2>
        <span class="order_price">¥{{v.price/100}}</span>
        <div class="timeItem">
          <span>{{v.startToEnd}}</span>
          <span v-if="v.weekdays && v.weekdays.split('、').length == 7">每天 {{v.dayTime}}</span>
          <span v-else-if="v.weekdays && v.weekdays.split('、').length > 3">每周{{v.dayTime}}</span>
          <span
            v-else-if="v.weekdays && v.weekdays.split('、').length <= 3"
          >每周{{v.weekdays}} {{v.dayTime}}</span>
        </div>
        <p class="lesson_num">共{{v.courseNum}}课时</p>
        <div class="lesson_item_mes">
          <div class="box">
            <img :src="v.teacherList.lecturer.url" />
            <div class="r_box">
              <span class="name">{{v.teacherList.lecturer.name}}</span>
              <span class="role">主讲</span>
            </div>
          </div>
          <div class="box">
            <img :src="v.teacherList.adviser.url" />
            <div class="r_box">
              <span class="name">{{v.teacherList.adviser.name}}</span>
              <span class="name">辅导老师</span>
            </div>
          </div>
        </div>
      </div>
      <p class="line"></p>
      <div v-if="v.gift && v.gift.length != 0" class="gift_item">
        <i>赠品</i>
        <span v-for="(item, index) in v.gift" v-if="index < 3">{{item.value}}</span>
      </div>
    </div>
    <div class="order_item">
      <div class="list">
        课程原价
        <span class="fr font_color_b6b">¥{{data.originPrice/100}}</span>
      </div>
      <div class="list">
        实付金额
        <span class="fr font_color_ff7">¥{{data.totalPrice/100}}</span>
      </div>
    </div>
    <div class="order_item pd_b">
      <div class="list">
        订单编号
        <i class="copy_btn fr" @click="copy_event(data.orderId)">复制</i>
        <span class="fr font_color_b6b">{{data.orderId}}</span>
      </div>
      <div class="list">
        下单时间
        <span class="fr font_color_b6b">{{data.orderTime}}</span>
      </div>
      <div class="list" v-if="data.orderState == 2">
        支付时间
        <span class="fr font_color_b6b">{{data.payTime}}</span>
      </div>
    </div>
    <p v-if="data.orderState == 1" class="pay_btn" @click="pay_event(data.orderId)">立即支付</p>
    <div v-if="tips" class="mark" @touchmove.prevent>
      <div class="tips" @click.stop>
        <p>
          真的要放弃
          <br />和小伙伴一起进步的机会吗？
        </p>
        <div class="btn">
          <span @click="exit_click">残忍离开</span>
          <span @click="hide_tips">一起进步</span>
        </div>
      </div>
    </div>
    <lesson_loading v-if="loadingLock" :status="status"></lesson_loading>
  </div>
</template>

<script>
import ajax from "@/api/ajax";
import utils from "@/assets/js/utils";
import lesson_loading from "@/components/common/lesson_loading.vue";
import titleBar from "@/components/common/titleBar.vue";
import time_count from "@/components/common/time_count.vue";
export default {
  name: "",
  data() {
    return {
      title: "订单详情",
      tips: false,
      data: "",
      token: "",
      version: "",
      source: "",
      orderId: "",
      loadingLock: true,
      status: "loading"
    };
  },
  methods: {
    exit_event: function() {
      let self = this;
      if (this.data.orderState != 1) {
        return this.$router.go(-1);
      }
      utils.sendLog(
        {
          token: self.token,
          version: "3.3.0",
          source: "h5"
        },
        "jz0356"
      );
      this.tips = true;
    },
    exit_click: function() {
      this.$router.go(-1);
    },
    hide_tips: function() {
      let self = this;
      utils.sendLog(
        {
          token: self.token,
          version: "3.3.0",
          source: "h5"
        },
        "jz0357"
      );
      this.tips = false;
    },
    initData: async function() {
      let self = this;
      const [resp] = await ajax.all([
        ajax.get("/parent/live/order-info", {
          params: {
            token: self.token,
            version: self.version,
            source: self.source,
            orderId: self.orderId
          }
        })
      ]);
      console.log(resp.data);
      if (resp.data.code == 99999) {
        self.loadingLock = false;
        self.data = resp.data.data;
        if (self.data.orderState == 1) {
          utils.sendLog(
            {
              token: self.token,
              version: "3.3.0",
              source: "h5",
              extensionJson: {
                orderID: self.orderId
              }
            },
            "jz0354"
          );
        }
      } else {
        self.loadingLock = true;
        self.status = "error";
      }
    },
    time_count_end: function() {
      this.initData();
    },
    copy_event: function(orderId) {
      window.location = "hybird://method/copy2Clipboard?content=" + orderId;
    },
    pay_event: function(orderId) {
      let self = this;
      utils.sendLog(
        {
          token: self.token,
          version: "3.3.0",
          source: "h5",
          extensionJson: {
            orderID: self.orderId
          }
        },
        "jz0355",
        function() {
          let url =
            window.location.origin +
            "/#/lesson/pay_sucess?token=" +
            self.token +
            "&version=" +
            self.version +
            "&source=" +
            self.source +
            "&sourceId=" +
            self.sourceId +
            "&hideTitleBar=1";
          window.location =
            "hybird://method/payLiveCourse?orderId=" +
            orderId +
            "&succesUrl=" +
            escape(url);
        }
      );
    }
  },
  components: {
    lesson_loading,
    titleBar,
    time_count
  },
  created: function() {
    this.token = utils.getQueryString("token");
    this.version = utils.getQueryString("version");
    this.source = utils.getQueryString("source");
    this.orderId = utils.getQueryString("orderId");
    this.initData();
  }
};
</script>

<style lang="scss" scoped>
.order_detail {
  .wait_pay {
    margin-top: 0.88rem;
    height: 0.9rem;
    line-height: 0.9rem;
    text-align: 0.9rem;
    background-color: #ff714c;
    font-family: PingFangSC-Medium;
    font-size: 0.32rem;
    color: #ffffff;
    text-align: center;
  }
  .pay_status {
    margin-top: 0.88rem;
    padding-top: 0.5rem;
    height: 1.6rem;
    text-align: center;
    background: #fff;
    i {
      margin-right: 0.2rem;
      display: inline-block;
      width: 0.5rem;
      height: 0.5rem;
      vertical-align: bottom;
    }
    .cannel_icon {
      background: url("../../assets/images/lesson/order_cannel.png") 0 0 / cover
        no-repeat;
    }
    .sucess_icon {
      background: url("../../assets/images/lesson/order_sucess.png") 0 0 / cover
        no-repeat;
    }
    .cannel_font {
      color: #b0b2c0;
    }
    .sucess_font {
      color: #e7be85;
    }
    span {
      font-family: PingFangSC-Medium;
      font-size: 0.38rem;
      line-height: 0.5rem;
    }
  }
  .order_mes {
    margin-top: 0.2rem;
    padding: 0.27rem 0.3rem 0.25rem;
    background: #fff;
    .mes_top {
      font-family: PingFangSC-Medium;
      font-size: 0.34rem;
      color: #56586a;
      i {
        margin-right: 0.16rem;
        width: 0.23rem;
        height: 0.3rem;
        display: inline-block;
        background: url("../../assets/images/lesson/ad_icon.png") 0 0 / cover
          no-repeat;
      }
      .name {
        margin-right: 0.15rem;
      }
    }
    .ad_mes {
      padding: 0.2rem 0.4rem 0;
      font-family: PingFangSC-Medium;
      font-size: 0.28rem;
      line-height: 0.38rem;
      color: #b0b2c0;
    }
  }
  .lessonItem {
    background-color: #fff;
    margin-top: 0.2rem;
    padding: 0.4rem 0.3rem;
    .item {
      position: relative;
      margin-top: 0.2rem;
      padding-bottom: 0.4rem;
      // border-bottom: 1px solid #eeeeee;
      h2 {
        margin-bottom: 0.13rem;
        margin-right: 0.8rem;
        line-height: 0.4rem;
        font-family: PingFangSC-Medium;
        font-size: 0.34rem;
        color: #56586a;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .order_price {
        position: absolute;
        top: 0.1rem;
        right: 0;
        font-family: PingFangSC-Medium;
        font-size: 0.36rem;
        line-height: 0.27rem;
        color: #ff714c;
      }
      .timeItem {
        span {
          &:last-child {
            margin-left: 0.1rem;
          }
        }
        line-height: 0.25rem;
        font-family: PingFangSC-Regular;
        font-size: 0.26rem;
        color: #9796a4;
      }
      .lesson_num {
        margin-top: 0.25rem;
        font-family: PingFangSC-Medium;
        font-size: 0.26rem;
        color: #9796a4;
      }
      .lesson_item_mes {
        margin-top: 0.36rem;
        height: 0.54rem;
        .box {
          float: left;
          &:first-child {
            width: 2.5rem;
          }
          img {
            width: 0.5rem;
            height: 0.5rem;
            border-radius: 50%;
            float: left;
          }
          .r_box {
            float: left;
            span {
              margin-left: 0.2rem;
              display: block;
              height: 0.22rem;
              line-height: 0.22rem;
              &:first-child {
                margin-bottom: 0.1rem;
              }
            }
            .name {
              font-family: PingFangSC-Regular;
              font-size: 0.24rem;
              color: #56546c;
            }
            .role {
              font-family: PingFangSC-Regular;
              font-size: 0.22rem;
              color: #b0b2c0;
            }
          }
        }
      }
    }
    .line {
      width: 100%;
      height: 1px;
      background: #eeeeee;
      transform: scale(1, 0.5);
    }
    .gift_item {
      padding-top: 0.2rem;
      font-size: 0.22rem;
      i {
        margin-right: 0.17rem;
        display: inline-block;
        width: 0.9rem;
        height: 0.34rem;
        line-height: 0.32rem;
        text-align: center;
        border-radius: 0.17rem;
        border: 0.01rem solid #e7be85;
        font-family: PingFangSC-Regular;
        color: #e7be85;
      }
      span {
        margin-right: 0.2rem;
        font-family: PingFangSC-Medium;
        line-height: 0.34rem;
        color: #b6b6c1;
      }
    }
  }
  .order_item {
    margin-top: 0.2rem;
    padding: 0 0.3rem;
    background: #fff;
    font-family: PingFangSC-Medium;
    font-size: 0.3rem;
    color: #8387a0;
    .list {
      height: 0.88rem;
      line-height: 0.88rem;
      border-bottom: 0.01rem solid #eee;
      &:last-child {
        border: none;
      }
      .copy_btn {
        margin: 0.24rem 0 0 0.17rem;
        display: inline-block;
        width: 0.9rem;
        height: 0.4rem;
        border-radius: 0.2rem;
        border: 0.02rem solid #c0c1cd;
        font-family: PingFangSC-Medium;
        font-size: 0.22rem;
        line-height: 0.36rem;
        color: #8387a0;
        text-align: center;
      }
    }
    .font_color_838 {
      color: #8387a0;
    }
    .font_color_b6b {
      color: #b6b6c1;
    }
    .font_color_ff7 {
      color: #ff714c;
    }
  }
  .fl {
    float: left;
  }
  .fr {
    float: right;
  }
  .pd_b {
    padding-bottom: 0.5rem;
  }
  .pay_btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1.1rem;
    background-color: #f5833d;
    font-family: PingFangSC-Medium;
    font-size: 0.38rem;
    line-height: 1.1rem;
    color: #ffffff;
    text-align: center;
  }
  .mark {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.7);
    .tips {
      padding: 0.3rem 0.4rem 0;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      width: 5.8rem;
      height: 3.4rem;
      background: #fff;
      border-radius: 0.3rem;
      text-align: center;
      font-family: PingFangSC-Medium;
      p {
        margin-top: 0.32rem;
        font-size: 0.36rem;
        line-height: 0.57rem;
        color: #56586a;
      }
      .btn {
        margin-top: 0.4rem;
        overflow: hidden;
        span {
          display: inline-block;
          width: 2.35rem;
          height: 0.89rem;
          line-height: 0.89rem;
          font-size: 0.32rem;
          border-radius: 0.44rem;
          &:first-child {
            float: left;
            color: #e7be84;
            border: solid 1px #e7be84;
          }
          &:last-child {
            float: right;
            color: #fff;
            background-color: #e7be84;
            border: solid 1px #e7be84;
          }
        }
      }
    }
  }
}
</style>